import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import {
  AccessState,
  BoardQuestionConfigurations,
} from '../items-canvas/board-items/board-question-configurations';
import { UserService } from '../../../services/user.service';

@Component({
  selector: 'app-question-container',
  templateUrl: './question-container.component.html',
  styleUrls: ['./question-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class QuestionContainerComponent {
  @Input() state!: BoardQuestionConfigurations;
  @Input() static!: boolean;

  @Output() stateChanged = new EventEmitter<BoardQuestionConfigurations>();
  @Output() deleteItem = new EventEmitter<void>();
  @Output() contentSizeChanged = new EventEmitter<{ width: number; height: number }>();

  protected readonly AccessState = AccessState;

  constructor(protected userService: UserService) {}

  answerQuestion(answer) {
    if (!this.userService.userId) {
      return;
    }
    this.state.answers.set(this.userService.userId, answer.choice);
    this.stateChanged.emit(this.state);
  }
}
